import { useState } from "react";
import { useAuth, useLoad } from "../lib/api.jsx";
import { Wait, Tbl, Modal, F, money } from "../lib/ui.jsx";

export default function Packages() {
  const { act } = useAuth();
  const [d, reload] = useLoad("packages");
  const [e, setE] = useState(null);

  const open = (p) => setE(p
    ? { ...p, ftxt: p.features.map((x) => [x.item, x.quantity, x.note].join("|")).join("\n") }
    : { p_name: "", package_refer: "", duration: "1", type: "month", price: "", currency: "BDT", card_margin: "0", status: 1, gService: "", c_refer: "", ftxt: "" });

  const save = async () => {
    const features = e.ftxt.split("\n").filter(Boolean).map((l) => {
      const [item, quantity, note] = l.split("|");
      return { item: item?.trim(), quantity: quantity?.trim(), note: note?.trim() };
    });
    if (await act("package_save", { ...e, features }, "Package saved.")) { setE(null); reload(); }
  };

  return (
    <>
      <h1>Packages</h1>
      <div className="bar"><button className="btn" onClick={() => open()}>Add package</button></div>
      <Wait d={d}>
        {d && !d.error && (
          <Tbl rows={d.rows} onRowClick={open} cols={[
            ["Code", (p) => p.package_refer], ["Service", (p) => p.gService], ["Name", (p) => p.p_name],
            ["Period", (p) => `${p.duration} ${p.type}`], ["Price", (p) => money(p.price, p.currency)],
            ["Active subs", (p) => p.active_subs], ["Features", (p) => p.features.length],
            ["Status", (p) => (
              <select value={+p.status} onChange={(x) => act("package_status", { id: p.id, status: +x.target.value }, "Updated.").then(reload)}>
                <option value={1}>Active</option><option value={0}>Hidden</option>
              </select>
            )],
            ["", (p) => (
              <>
                <button className="btn g s" onClick={() => open(p)}>Edit</button>{" "}
                <button className="btn d s" onClick={() => confirm("Delete this package?") && act("package_delete", { id: p.id }, "Deleted.").then(reload)}>Delete</button>
              </>
            )],
          ]} />
        )}
      </Wait>
      {e && (
        <Modal title={e.id ? "Edit package" : "Add package"} onClose={() => setE(null)}>
          <div className="g2">
            <F label="Name" v={e.p_name} set={(v) => setE({ ...e, p_name: v })} />
            <F label="Package code" v={e.package_refer} set={(v) => setE({ ...e, package_refer: v })} />
            <F label="Service (gService)" v={e.gService} set={(v) => setE({ ...e, gService: v })} />
            <F label="Portal code (c_refer)" v={e.c_refer} set={(v) => setE({ ...e, c_refer: v })} />
            <F label="Duration" type="number" v={e.duration} set={(v) => setE({ ...e, duration: v })} />
            <div>
              <label>Period</label>
              <select value={e.type} onChange={(x) => setE({ ...e, type: x.target.value })}>
                {["day", "month", "year"].map((t) => <option key={t}>{t}</option>)}
              </select>
            </div>
            <F label="Price" type="number" v={e.price} set={(v) => setE({ ...e, price: v })} />
            <F label="Currency" v={e.currency} set={(v) => setE({ ...e, currency: v })} />
          </div>
          <label>Features, one per line as item|quantity|note</label>
          <textarea rows={5} value={e.ftxt} onChange={(x) => setE({ ...e, ftxt: x.target.value })} placeholder="roomLimit|5|5 Department / Room" />
          <div className="bar"><button className="btn" onClick={save}>Save package</button></div>
        </Modal>
      )}
    </>
  );
}
